

import http from "@/http/service"

export default function TokenParceiro(idParceiro=0){
    return http.get(`/admin/parceiros/${idParceiro}/token`)
}